
import React, { useState, useEffect} from "react";
import { Input, Select, Pagination, message } from 'antd';
import InvoiceTable from "./components/invoice-table";
import { titleList } from './config';
import { getOrderList, orderCountTotal } from '@/api/personal-center';
import NoData from '@/components/no-data';
import useBackToTop from '@/hooks/useBackToTop';
import searchImg from '../assets/search.png';

import { getBillList} from '@/api/my-invoice'
import './index.scss';

const MyInvoice: React.FC = () => {
 const { scrollToTop } = useBackToTop(300); // 调用自定义 Hook
 const [searchValue, setSearchValue] = useState('');
 const [orderData, setOrderData] = useState([]);
 const [pageNum, setPageNum] = useState(1); // 表格页码
 const [pageSize, setPageSize] = useState(10); // 表格页长
 const [isRefresh, setIsRefresh] = useState(false); // 更新列表
 const [dateType, setDateType] = useState(1); // 时间段
 const [status, setStatus] = useState(0); // 支付方式
  const [total, setTotal] = useState<number>();
 
//  const [orderStatus, setOrderStatus] = useState<any>(orderStatusArr); // 订单状态统计数据
 useEffect(() => {
   orderListFunc();
 },[dateType,status,pageNum,pageSize])

 useEffect(() => {
   if(isRefresh) {
     orderListFunc();
   }
 },[isRefresh])

 useEffect(() => {
   orderCountFunc();
 },[]);

 const orderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
   const { value } = e.target;
   setSearchValue(value);
 };
 // 订单状态统计
 const orderCountFunc = () => {
   orderCountTotal().then((oData:any) => {
     if(oData.success) {
       const getObj = oData.obj;
      //  const getStatus = [...orderStatus];
      //  getStatus[0].count = getObj.unpaid;
      //  getStatus[1].count = getObj.audit;
      //  getStatus[2].count = getObj.unReceive;
      //  setOrderStatus(getStatus);
     }
   })
 }

 // 搜索
 const orderSearch = () => {
   orderListFunc()
 }

 const handleChangePagination = (page: number, pageSize: number) => {
   setPageNum(page);
   setPageSize(pageSize);
   scrollToTop();
 };
 // 获取订单列表
 const orderListFunc = () => {

   const params:any = {status,pageNum,pageSize};
  
   if(searchValue !== '') {
     params.header = searchValue;
   }
   if (status !== 0) {
     params.status = status;
   } else { 
     params.status = null;
   }
   getBillList(params).then((gRes:any) => {
     if(gRes.success) {
       setOrderData(gRes.obj.list);
       setTotal(gRes.obj.total);
     }else {
       message.error(gRes.message);
     }
   })
 }
 // 支付方式切换
  const paySelectFunc = (value: number) => {
    setPageNum(1);
   setStatus(value);
 }
 // 时间段切换
 const timeSelectFunc = (value:number) => {
   setDateType(value);
 }
 return (
   <div className="my-invoice-list">
     <div className="order-head">
       我的发票
       <div className="search-input">
         <Input placeholder="商品名称/发票抬头" onChange={orderChange} onPressEnter={orderSearch} />
         <span onClick={()=>orderSearch()}><img src={searchImg} alt='' /></span>
       </div>
     </div>
     <div className="line"></div>
     <div className="order-list-content">
      
       
       <div className="list-header">
         {
           titleList.map((tData,index) => (
             <div key={index} style={{width: tData.width}} className="list-header-title">
               {
                 tData.list ?
                 <Select
                   style={{ width: tData.width }}
                   placeholder={tData.name}
                   onChange={paySelectFunc}
                   options={tData.list}
                   getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
                 />:
                 <>{tData.name}</>
               }
             </div>
           ))
         }
       </div>
       
       {
         orderData.length > 0 ?
           <>
           <InvoiceTable
             orderData={orderData}
             setIsRefresh={setIsRefresh}
           /> 
       <div className="page-bottom">
         <Pagination
           current={pageNum}
           pageSize={pageSize}
           total={total}
           onChange={(page, pageSize) =>
             handleChangePagination(page, pageSize)
           }
           showQuickJumper
           showSizeChanger={false}
         />
       </div></>:
         <NoData title='暂无数据' />
       }
     </div>
    
   </div>
 )
}

export default MyInvoice;
